export default "__VITE_ASSET__68e0445c__"